// A full navigation drops in-memory account data as well as the Parse session.
export async function signOut(userApi, navigate) {
  try {
    await userApi.logOut();
  } catch (error) {
    // Parse can clear the local session even when server revocation fails.
    if (userApi.current()) throw error;
  }
  navigate('/');
}
